import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { NEWS_ITEMS } from '../utils/constants';
import { ArrowRight } from 'lucide-react';

const NewsDetail = () => {
  const { slug } = useParams();
  const news = NEWS_ITEMS.find(item => item.slug === slug);

  if (!news) {
    return (
      <div className="min-h-screen bg-black text-white pt-24 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">News Not Found</h1>
          <Link to="/" className="text-white/60 hover:text-white underline">
            Return to Home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      <article className="max-w-4xl mx-auto px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Hero image placeholder */}
          {news.image && (
  <div className="h-80 rounded-2xl overflow-hidden mb-12">
    <img
      src={news.image}
      alt={news.title}
      className="w-full h-full object-contain"
    />
  </div>
)}

          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">
            {news.title}
          </h1>

          {/* Content */}
          <div className="prose prose-invert prose-lg max-w-none">
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              {news.excerpt}
            </p>

            <p className="text-white/70 text-lg leading-relaxed mb-6">
              In a groundbreaking development, Neufora continues to push the boundaries of artificial intelligence and robotics. Our team of researchers and engineers has been working tirelessly to bring these innovations to life, combining cutting-edge theory with practical applications.
            </p>

            <p className="text-white/70 text-lg leading-relaxed mb-6">
              This advancement represents a significant milestone in our mission to create intelligent systems that enhance human capabilities and solve real-world challenges. Through careful design, rigorous testing, and a commitment to excellence, we're building technology that makes a difference.
            </p>

            <p className="text-white/70 text-lg leading-relaxed mb-6">
              The implications of this work extend far beyond the laboratory. From healthcare to manufacturing, from education to environmental sustainability, the applications of these technologies have the potential to transform industries and improve lives.
            </p>

            <p className="text-white/70 text-lg leading-relaxed mb-12">
              As we continue to innovate and explore new frontiers, we remain committed to responsible development practices and ethical AI principles. Our work is guided by a vision of technology that serves humanity and creates a better future for all.
            </p>

            {/* Deep Dive Button */}
            <Link
              to="/coming-soon"
              className="inline-flex items-center px-8 py-4 bg-white text-black rounded-2xl font-medium hover:scale-[1.02] transition-transform duration-200"
            >
              Deep Dive
              <ArrowRight size={20} className="ml-2" />
            </Link>
          </div>
        </motion.div>
      </article>
    </div>
  );
};

export default NewsDetail;